/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of authentication required by the provider.
 * @export
 */
export const AuthType = {
    Oauth2: 'oauth2',
    ApiKey: 'apiKey',
    Basic: 'basic',
    Jwt: 'jwt',
    Custom: 'custom',
    None: 'none'
} as const;
export type AuthType = typeof AuthType[keyof typeof AuthType];


export function AuthTypeFromJSON(json: any): AuthType {
    return AuthTypeFromJSONTyped(json, false);
}

export function AuthTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthType {
    return json as AuthType;
}

export function AuthTypeToJSON(value?: AuthType | null): any {
    return value as any;
}

